var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.value
        ? _c("ModalFullScreen", {
            attrs: { size: "MB", title: "New Conversation" },
            on: { close: _vm.handleClose },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c("UsersSelect", {
                        attrs: {
                          companyId: _vm.companyId,
                          currentUserId: _vm.currentUserId,
                          currentUserRole: _vm.currentUserRole,
                        },
                        model: {
                          value: _vm.user,
                          callback: function ($$v) {
                            _vm.user = $$v
                          },
                          expression: "user",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "flex mt-10 justify-end w-full" },
                        [
                          _c("UiButton", {
                            staticClass: "mr-4",
                            attrs: {
                              id: "cancelMessage",
                              buttonText: "Cancel",
                              size: "lg",
                              variant: "outline",
                            },
                            on: { click: _vm.handleClose },
                          }),
                          _c("UiButton", {
                            attrs: {
                              buttonText: "Create",
                              size: "lg",
                              variant: "black",
                              id: "createMessage",
                              disabled: !_vm.user,
                            },
                            on: { click: _vm.sendMessage },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2348486742
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }